import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import React from "react";
import { memoForwardRef } from "@shared/client/util/memo";
import "./popover.scss";
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverContent = memoForwardRef(({ className, sideOffset = 6, align = "center", ...rest }, ref) => (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Content, { ref: ref, sideOffset: sideOffset, align: align, className: ["popover", className].filter(Boolean).join(" "), ...rest }) })));
PopoverContent.displayName = "PopoverContent";
export const PopoverArrow = memoForwardRef(({ className, ...rest }, ref) => (_jsx(PopoverPrimitive.Arrow, { ref: ref, className: ["popover__arrow", className].filter(Boolean).join(" "), ...rest })));
PopoverArrow.displayName = "PopoverArrow";
